import {SaveDecorationGuidRequest} from '../models/Decorations/IDecorationGuid';

export interface DecorationGuidDraft {
    id?: string;
    name: string;
    description: string;
    items: Array<{id?: string; itemId: string; quantity: number; deleted?: boolean}>;
    priceOptions: Array<{id?: string; quantity: number; price: number; deleted?: boolean}>;
}

export const toSaveDecorationGuidRequest = (draft: DecorationGuidDraft, includeId: boolean): SaveDecorationGuidRequest => ({
    ...(includeId && draft.id ? {id: draft.id} : {}),
    name: draft.name.trim(),
    description: draft.description.trim(),
    items: draft.items.filter(item => !item.deleted).map(({id, itemId, quantity}) => ({...(includeId && id ? {id} : {}), itemId, quantity})),
    priceOptions: draft.priceOptions.filter(option => !option.deleted).map(({id, quantity, price}) => ({...(includeId && id ? {id} : {}), quantity, price})),
});
